import React from "react"
import { Box } from "rebass"

const Cloud = ({ color, upsideDown }) => {
  const id = `dropshadow-${color}`
  const upsideDownStyle = upsideDown
    ? {
        transform: `rotate(180deg)`,
      }
    : {}
  return (
    <Box
      as="svg"
      viewBox="0 0 374 218"
      sx={{
        width: [160, 250],
        ...upsideDownStyle,
      }}
      style={{ overflow: "visible", pointerEvents: "none" }}
    >
      <defs>
        <filter
          id={id}
          width="125%"
          height="150%"
          x="-10%"
          y="-20%"
          filterUnits="userSpaceOnUse"
        >
          <feDropShadow
            floodColor={color}
            floodOpacity={0.65}
            dx="10"
            dy="5"
            stdDeviation="20"
          />
        </filter>
      </defs>
      <path
        d="M327.371,93.794c-2.639,-31.863 -29.37,-56.906 -61.98,-56.906c-5.161,0 -10.171,0.638 -14.967,1.821c-9.254,-22.7 -31.565,-38.709 -57.635,-38.709c-20.791,0 -39.188,10.19 -50.485,25.827c-9.712,-6.26 -21.273,-9.907 -33.696,-9.907c-34.312,0 -62.134,27.723 -62.208,61.949c-25.628,0 -46.4,20.729 -46.4,46.302c0,25.572 20.772,46.302 46.397,46.302c3.407,0 6.725,-0.377 9.923,-1.072c6.076,18.507 23.513,31.88 44.09,31.88c11.333,0 21.712,-4.06 29.77,-10.796c13.647,16.61 36.594,27.515 62.609,27.515c21.534,0 40.953,-7.481 54.749,-19.472c6.571,2.356 13.651,3.647 21.035,3.647c17.217,0 32.799,-6.982 44.063,-18.259c4.698,1.596 9.729,2.475 14.967,2.475c25.625,0 46.397,-20.729 46.397,-46.301c0,-25.572 -20.772,-46.302 -46.397,-46.302c-0.077,0 -0.154,0.005 -0.232,0.006Z"
        style={{ fill: "white", filter: `url('#${id}')` }}
      />
    </Box>
  )
}

export default Cloud
